module.exports = __webpack_public_path__ + "static/media/csm.e41a9671.svg";